import { FilterCompanyBankAccountsWebPage, getCompanyBankAccountsWebPage } from 'commons/service/bank/companyDetails'
import { CompanyBankAccountsWebPage } from 'commons/types/DTO/bank/companyDetails/bankAccount'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyBankAccountsWebPage: WriteHook<
  FilterCompanyBankAccountsWebPage,
  CompanyBankAccountsWebPage
> = (opts) => useMutationManager(getCompanyBankAccountsWebPage, opts)
